import React from 'react';
import EmployeeButton from './EmployeeButton';

const UsersList = (props) => {

    const { users, clients, userSize, role, employee } = props;

    return (
        <article className="user-list">
            <header>
                <div className="title">
                    ユーザ一覧 <span className="badge badge-light ml-2">
                        {userSize}
                    </span>
                </div>
                <div className="tool">
                    <a className="btn btn-primary btn-sm u-ml20" href={`/desk/clients/${clients.id}/users/new`}>管理者追加</a>
                </div>
            </header>

            <header className="hoge">
                <div className="user-id">
                    ID
                </div>
                <div className="user-email">
                    メールアドレス
                </div>
                <div className="user-permission">
                    権限
                </div>
                <div className="user-controls">
                    操作
                </div>
            </header>

            {users.map((user) => {
                return (
                    <section key={user.id}>
                        <div className="user-id">
                            {user.id}
                        </div>
                        <div className="user-email">
                            <a className="btn btn-light btn-sm" href={`/desk/clients/${clients.id}/users/${user.id}`}>{user.email? user.email : 'なし'}</a>
                            {user.onlyEnrollmentInput? <span className="badge badge-info">入社の手続きのみ</span> : undefined }
                        </div>
                        <div className="user-permission">
                            {role}
                        </div>
                        <div className="user-controls d-flex flex-row-reverse">
                            <a className="btn btn-primary ml-2" href={`/desk/clients/${clients.id}/users/${user.id}`}>表示</a>
                            <EmployeeButton employee={employee} clients={clients}/>
                        </div>
                        
                    </section>
                )   
            })}
        </article>
    )
}

export default UsersList
